import { getLanguage, setLanguage as saveLanguage } from '../store';

const messages = {
  en: {
    appTitle: 'ExAgent Console',
    actions: {
      detail: 'Detail',
      login: 'Login',
      logout: 'Logout',
      search: 'Search'
    },
    common: {
      actions: 'Actions',
      actualPaid: 'Actual paid',
      actualPayout: 'Actual payout',
      amount: 'Amount',
      applicationTime: 'Application time',
      areaCode: 'Area code',
      auditTime: 'Audit time',
      balance: 'Balance',
      channel: 'Channel',
      commission: 'Estimated commission',
      connectionFailed: 'Connection failed',
      createdAt: 'Created time',
      currency: 'Currency',
      currentCommissionRules: 'Current commission rules',
      currentRechargeTotal: 'Recharge total for current filters',
      date: 'Date',
      dateRangeTooLong: 'Date range cannot exceed 31 days',
      email: 'Email',
      end: 'End',
      error: 'Error',
      exchangeRate: 'Exchange rate',
      failReason: 'Fail Reason',
      firstRechargeUsers: 'First recharge users',
      hitTurnover: 'Matched turnover',
      max: 'Max',
      min: 'Min',
      month: 'Month',
      noLimit: 'Above',
      orderId: 'Order ID',
      packageName: 'Package',
      password: 'Password',
      payChannel: 'Payment channel',
      payMethod: 'Payment method',
      payStatus: 'Payment status',
      phone: 'Phone',
      ratePercent: 'Rate (%)',
      rechargeAmount: 'Recharge amount',
      rechargeUsers: 'Recharge users',
      requestFailed: 'Request failed',
      reviewStatus: 'Review status',
      sourceAmount: 'Original recharge',
      sourceCurrency: 'Original currency',
      start: 'Start',
      status: 'Status',
      submitTime: 'Submit time',
      targetAmount: 'Converted amount',
      targetCurrency: 'Settlement currency',
      thirdOrderNo: 'Third-party order no',
      totalEarnings: 'Total earnings',
      transferableBalance: 'Transferable balance',
      updatedAt: 'Updated time',
      userId: 'User ID',
      walletBalance: 'Wallet balance',
      username: 'Username',
      withdrawAmount: 'Withdraw amount',
      withdrawUsers: 'Withdraw users'
    },
    login: {
      missing: 'Please enter username and password'
    },
    menu: {
      commission: 'Commission',
      dashboard: 'Acquisition stats',
      recharges: 'Recharge data',
      settlements: 'Settlements',
      users: 'Users',
      withdraws: 'Withdraw data'
    },
    pages: {
      activeUsers: 'Daily logins',
      commission: 'ExAgent commission',
      convertedTurnover: 'Converted turnover',
      currencyDetails: 'Currency details',
      dashboard: 'Acquisition stats',
      day1Retention: 'D1 retention',
      day3Retention: 'D3 retention',
      day7Retention: 'D7 retention',
      newPaidAmount: 'New paid amount',
      newPaidUsers: 'New paid users',
      newRegisteredAccounts: 'Registered accounts',
      newUsers: 'New accounts',
      rechargeTotal: 'Recharge total',
      recharges: 'Recharge data',
      settlementDetail: 'Settlement detail',
      settlementRecharge: 'Settlement turnover',
      settlements: 'Settlements',
      successfulRechargeAmount: 'Successful recharge amount',
      successfulWithdrawAmount: 'Successful withdraw amount',
      teamSuccessfulRecharge: 'Team successful recharge',
      tierDetails: 'Tier details',
      users: 'Users',
      withdrawRealTotal: 'Actual payout total',
      withdrawTotal: 'Withdraw total',
      withdraws: 'Withdraw data'
    },
    status: {
      hold: 'Hold',
      pending: 'Pending',
      settled: 'Settled'
    },
    payRecordStatus: {
      failed: 'Failed',
      ready: 'Pending',
      refunded: 'Refunded',
      riskReview: 'Risk review',
      rolledBack: 'Rolled back',
      submitted: 'Submitted',
      success: 'Success',
      utr: 'UTR submitted'
    },
    reviewRecordStatus: {
      humanPass: 'Manual approved',
      humanReject: 'Manual rejected',
      programPass: 'Auto approved',
      programReject: 'Auto rejected',
      ready: 'Pending review'
    }
  },
  fr: {
    appTitle: 'Console ExAgent',
    actions: {
      detail: 'Detail',
      login: 'Connexion',
      logout: 'Deconnexion',
      search: 'Rechercher'
    },
    common: {
      actions: 'Actions',
      actualPaid: 'Paiement reel',
      actualPayout: 'Paiement effectif',
      amount: 'Montant',
      applicationTime: 'Date de demande',
      areaCode: 'Indicatif',
      auditTime: 'Date de validation',
      balance: 'Solde',
      channel: 'Canal',
      commission: 'Commission estimee',
      connectionFailed: 'Echec de la connexion',
      createdAt: 'Date de creation',
      currency: 'Devise',
      currentCommissionRules: 'Regles de commission actuelles',
      currentRechargeTotal: 'Total des depots selon les filtres',
      date: 'Date',
      dateRangeTooLong: 'La plage de dates ne peut pas depasser 31 jours',
      email: 'Email',
      end: 'Fin',
      error: 'Erreur',
      exchangeRate: 'Taux de change',
      failReason: "Raison de l'echec",
      firstRechargeUsers: 'Premiers depots',
      hitTurnover: 'Chiffre retenu',
      max: 'Maximum',
      min: 'Minimum',
      month: 'Mois',
      noLimit: 'Au-dessus',
      orderId: 'ID commande',
      packageName: 'Package',
      password: 'Mot de passe',
      payChannel: 'Canal de paiement',
      payMethod: 'Mode de paiement',
      payStatus: 'Statut paiement',
      phone: 'Telephone',
      ratePercent: 'Taux (%)',
      rechargeAmount: 'Montant depose',
      rechargeUsers: 'Utilisateurs deposants',
      requestFailed: 'La requete a echoue',
      reviewStatus: 'Statut de revue',
      sourceAmount: 'Depot initial',
      sourceCurrency: 'Devise initiale',
      start: 'Debut',
      status: 'Statut',
      submitTime: 'Date de soumission',
      targetAmount: 'Montant converti',
      targetCurrency: 'Devise de reglement',
      thirdOrderNo: 'No commande tiers',
      totalEarnings: 'Gains totaux',
      transferableBalance: 'Solde transferable',
      updatedAt: 'Date de mise a jour',
      userId: 'ID utilisateur',
      walletBalance: 'Solde portefeuille',
      username: "Nom d'utilisateur",
      withdrawAmount: 'Montant retire',
      withdrawUsers: 'Utilisateurs ayant retire'
    },
    login: {
      missing: "Veuillez saisir le nom d'utilisateur et le mot de passe"
    },
    menu: {
      commission: 'Commission',
      dashboard: 'Acquisition',
      recharges: 'Depots',
      settlements: 'Reglements',
      users: 'Utilisateurs',
      withdraws: 'Retraits'
    },
    pages: {
      activeUsers: 'Connexions du jour',
      commission: 'Commission ExAgent',
      convertedTurnover: 'Chiffre converti',
      currencyDetails: 'Details des devises',
      dashboard: 'Statistiques acquisition',
      day1Retention: 'Retention J1',
      day3Retention: 'Retention J3',
      day7Retention: 'Retention J7',
      newPaidAmount: 'Montant des nouveaux payeurs',
      newPaidUsers: 'Nouveaux payeurs',
      newRegisteredAccounts: 'Comptes inscrits',
      newUsers: 'Nouveaux comptes',
      rechargeTotal: 'Total des depots',
      recharges: 'Donnees de depot',
      settlementDetail: 'Detail du reglement',
      settlementRecharge: 'Chiffre de reglement',
      settlements: 'Reglements',
      successfulRechargeAmount: 'Montant des depots reussis',
      successfulWithdrawAmount: 'Montant des retraits reussis',
      teamSuccessfulRecharge: 'Depot reussi equipe',
      tierDetails: 'Details par palier',
      users: 'Utilisateurs',
      withdrawRealTotal: 'Total paiement effectif',
      withdrawTotal: 'Total des retraits',
      withdraws: 'Donnees de retrait'
    },
    status: {
      hold: 'En attente',
      pending: 'En attente de validation',
      settled: 'Regle'
    },
    payRecordStatus: {
      failed: 'Echoue',
      ready: 'En attente',
      refunded: 'Rembourse',
      riskReview: 'Controle risque',
      rolledBack: 'Annule',
      submitted: 'Soumis',
      success: 'Reussi',
      utr: 'UTR soumis'
    },
    reviewRecordStatus: {
      humanPass: 'Validation manuelle',
      humanReject: 'Rejet manuel',
      programPass: 'Validation auto',
      programReject: 'Rejet auto',
      ready: 'En attente de revue'
    }
  }
};

export const i18nState = {
  language: normalizeLanguage(getLanguage())
};

export function normalizeLanguage(language) {
  language = String(language || '').toLowerCase();
  if (language.indexOf('fr') === 0) return 'fr';
  if (language.indexOf('en') === 0) return 'en';
  return 'en';
}

export function setLanguage(language) {
  const value = normalizeLanguage(language);
  saveLanguage(value);
  i18nState.language = value;
  return value;
}

export function t(key) {
  const language = normalizeLanguage(i18nState.language);
  const parts = key.split('.');
  let current = messages[language];
  for (let i = 0; i < parts.length; i += 1) {
    current = current && current[parts[i]];
  }
  if (current) return current;
  current = messages.en;
  for (let i = 0; i < parts.length; i += 1) {
    current = current && current[parts[i]];
  }
  return current || key;
}

export default {
  install(Vue) {
    const reactiveState = Vue.observable(i18nState);
    Vue.prototype.$i18nState = reactiveState;
    Vue.prototype.$setLanguage = setLanguage;
    Vue.prototype.$t = t;
  }
};



// WEBPACK FOOTER //
// ./src/i18n/index.js